import { Component, Inject } from '@angular/core';
import { EnvironmentToken } from '../../../util';
import { Environment } from '../../../typings';

@Component({
    selector: 'app-eeoc-info-bar',
    templateUrl: './eeoc-info-bar.component.html',
    styleUrls: ['./eeoc-info-bar.component.scss'],
    standalone: false
})
export class EeocInfoBarComponent {
  constructor(@Inject(EnvironmentToken) private environment: Environment) {}

  openWebsite(): void {
    top.location.replace(this.environment.aquentWebsite);
  }
}
